import i18n from "i18next";
// eslint-disable-next-line no-restricted-imports
import { Settings } from "luxon";

i18n.on("languageChanged", (lng) => {
    Settings.defaultLocale = lng;
});
